<template>
  <div class="btn-group table-column-menu">
    {{ title }}

    <div class="table-column-menu-filter">
      <a href="javascript:;" :id="targetId">
        <font-awesome-icon
          :icon="['fas', 'filter']"
          :class="{ 'text-muted': !filtedApplied, 'icon alt': true }"
        />
      </a>
    </div>

    <div class="table-column-menu-sort">
      <slot name="sort"> </slot>
    </div>

    <b-popover
      :target="targetId"
      triggers="click"
      :show.sync="popoverShow"
      placement="right"
      container="gridFiltersContainer"
      ref="popover"
    >
      <div class="mhtable-filter-body">
        <label>Zobrazit položky kde hodnota:</label>
        <b-form-select
          v-model="selectedFilterType"
          :options="filterOptions"
          class="mb-3"
        />
        <input
          type="search"
          class="form-control"
          ref="input"
          v-model="keyword"
        />
      </div>
      <div class="mhtable-filter-menu">
        <button
          type="submit"
          class="k-button k-primary"
          @click="search"
          aria-label="Search"
          >Filtrovat</button
        >
        <button type="reset" class="k-button" @click="reset" aria-label="Close"
          >Zrušit</button
        >
      </div>
    </b-popover>
  </div>
</template>
<script>
export default {
  props: ['field', 'title', 'query'],
  data() {
    return {
      keyword: '',
      filtedApplied: false,
      popoverShow: false,
      targetId: 'filterMenuPopover' + this.field,
      selectedFilterType: 'begin',
      filterOptions: [
        { value: 'begin', text: 'Začíná na' },
        { value: 'contain', text: 'Obsahuje' },
        { value: 'notcontain', text: 'Neobsahuje' },
        { value: 'eq', text: 'Je rovna' },
        { value: 'neq', text: 'Není rovna' },
        { value: 'empty', text: 'Je prázdná' },
        { value: 'notempty', text: 'Není prázdná' },
      ],
    }
  },
  mounted() {
    this.$el.addEventListener('click', this.onClick)

    let filtered = this.query.filters.find((x) => x.dataIndx === this.field)
    if (filtered != null) {
      this.keyword = filtered.value
      this.filtedApplied = true
    }
  },
  beforeDestroy() {
    this.$el.removeEventListener('click', this.onClick)
  },
  methods: {
    onClick(e) {
      this.$refs.input.focus()
    },
    onClose() {
      this.popoverShow = false
    },
    search(e, reset) {
      let isReset = reset || false

      if (this.keyword && this.keyword.length > 0) {
        this.filtedApplied = true
      } else {
        this.filtedApplied = false
      }

      const { query } = this

      let filterObj = {
        dataIndx: this.field,
        value: this.keyword,
        condition: this.selectedFilterType,
        dataType: 'string',
        cbFn: '',
      }

      let filtered = query.filters.find((x) => x.dataIndx === this.field)

      if (filtered != null && filtered != undefined) {
        Object.assign(filtered, filterObj)
      } else if (isReset === false) {
        query.filters.push(filterObj)
      }

      query.offset = 0 // reset pagination

      this.onClose()
    },
    reset() {
      const { query } = this

      let filtered = query.filters.filter((x) => x.dataIndx !== this.field)
      query.filters = filtered

      this.selectedFilterType = this.filterOptions[0].value

      this.keyword = ''
      this.search(null, true)
    },
  },
}
</script>

<style>
input[type='search']::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
  cursor: pointer;
}
.table-column-menu {
  width: 100%;
}

.table-column-menu-filter {
  text-align: right;
  position: absolute;
  top: 0;
  right: 0;
}

.btn-group,
.btn-group-vertical {
  vertical-align: initial;
}
</style>
